<template>
  <div class="payment-info-profiles-count">
    <div class="payment-info-profiles-count-title">
      <div class="payment-info-title-text">
        {{ $t('plans.additionalProfiles') }}
      </div>

      <span
        class="payment-info-extra-profiles-available"
      >
        {{
          $t('plans.willBeAvailableProfiles',
          [FREE_TARIFF_NAME, ENTERPRISE_TARIFF_NAME].includes(paymentInfo.plan) ?
          [paymentInfo.profilesCount + paymentInfo.additionalProfiles] : [paymentInfo.profilesCount])
        }}
      </span>
    </div>
    <!-- ДОПОЛНИТЕЛЬНЫЕ ПРОФИЛИ -->
    <div v-if="paymentInfo.plan === FREE_TARIFF_NAME">
      <div class="payment-info-extra-profiles-select">
        <dolphin-select
          :options="additionalProfiles"
          :default="defaultProfileCount"
          @input="handleChangeExtraProfiles($event)"
        />
      </div>
    </div>
    <!-- КОЛИЧЕСТВО ПРОФИЛЕЙ В ЗАДИЗЕЙБЛЕННОМ СЕЛЕКТЕ -->
    <div v-if="paymentInfo.plan !== FREE_TARIFF_NAME">
      <div class="payment-info-extra-profiles-select">
        <dolphin-select :options="[0]" :disabled="true" :default="0" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {
    ENTERPRISE_TARIFF_NAME,
    FREE_TARIFF_NAME
  } from "@/constants/plans";
  import DolphinSelect from "@/components/custom/DolphinSelect";
  import calculations from '@/mixins/calculations'

  export default {
    name: 'PaymentDialogProfilesCount',

    components: {
      DolphinSelect
    },
    mixins: [calculations],

    data () {
      return {
        FREE_TARIFF_NAME,
        ENTERPRISE_TARIFF_NAME
      }
    },

    computed: {
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        profile: 'main/profile'
      }),

      additionalProfiles () {
        return [0, 10, 20, 30, 40, 50]
      },

      defaultProfileCount () {
        const isFreePlan = this.profile.subscription.plan === FREE_TARIFF_NAME &&
          !this.profile.subscription.browserProfiles.additionalProfiles

        const isExpired = this.getDaysUntilExpiration(this.profile.subscription.expiration) <= 0

        return this.additionalProfiles[isFreePlan || isExpired ? 0 : 1]
      }
    },

    methods: {
      handleChangeExtraProfiles (value) {
        this.paymentInfo.additionalProfiles = value
      }
    }
  }
</script>

<style>
  .payment-info-profiles-count {
    margin-top: 24px;
  }

  .payment-info-extra-profiles-select {
    margin-top: 6px;
  }

  .payment-info-extra-profiles-available {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #555E71;
    opacity: 0.4;
    margin-left: 6px;
  }

  .payment-info-profiles-count-title {
    display: flex;
    align-items: center;
  }
</style>